import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { SetupExcpParam, ItemList } from 'models/setup/excp/excp';
import { SetupProject } from 'models/setup/SetupProject';

import { callApi } from 'utils/ApiUtil';

export const getSetupItemList = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/itemList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<ItemList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ItemList[];
};

export const findProjectListForExcp = async (condition?: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/projectList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...(condition || {}),
    }),
  };
  const response: CommonResponse<SetupProject[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProject[];
};

export const saveItemList = async (condition: ItemList) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/saveSetupPakItem`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const getProjectItemCnt = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/itemListCnt`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupExcpParam> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupExcpParam;
};
